import api from "api/api";

export const getTtvList = async () => await api.get("/settings/ttv");

export const getTtvById = async (id) => await api.get(`/settings/ttv/${id}`);

export const createTtv = async (data) => await api.post("/settings/ttv", data);

export const updateTtvById = async (id, data) =>
  await api.put(`/settings/ttv/${id}`, data);

export const deleteTtvById = async (id) =>
  await api.delete(`/settings/ttv/${id}`);
